import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import { useTheme, jsx } from '@emotion/react';
import Loader from '../../shared-components/loader/index.js';
import Style from './style.js';
import withDeprecationWarning from '../../../../utils/withDeprecationWarning/index.js';
import { deprecatedProperties } from '../../deprecatedPropsHandler.js';
import { isDefined } from '../../../../utils/isDefined/index.js';

var _excluded = ["buttonColor", "buttonType", "children", "disabled", "icon", "isLoading", "loading", "onClick", "textColor"];
var RoundButton = _ref => {
  var {
    buttonColor,
    buttonType = 'primary',
    children,
    disabled = false,
    icon,
    isLoading = false,
    loading = undefined,
    onClick = () => undefined,
    textColor
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  var theme = useTheme();
  var buttonColorWithTheme = buttonColor !== null && buttonColor !== void 0 ? buttonColor : theme.COLORS.primary;
  var loadingVal = loading === undefined ? isLoading : loading;
  return jsx(Style.RoundButtonWrapper, null, jsx(Style.RoundButtonBase, _extends({
    onClick: !disabled && !isLoading ? onClick : () => false,
    disabled: disabled,
    buttonType: buttonType,
    buttonColor: buttonColorWithTheme,
    isLoading: loadingVal,
    type: "button",
    isFullWidth: false,
    textColor: textColor // eslint-disable-next-line react/jsx-props-no-spreading

  }, rest), icon, jsx(Loader, {
    buttonColor: buttonColorWithTheme,
    buttonType: buttonType,
    disabled: disabled,
    css: Style.roundButtonLoader(disabled, theme),
    isLoading: loadingVal,
    textColor: textColor
  })), isDefined(children) && jsx("p", {
    css: Style.roundButtonTextStyles(buttonColorWithTheme, theme, textColor)
  }, children));
};
RoundButton.Container = Style.RoundButtonContainer;
withDeprecationWarning(RoundButton, deprecatedProperties);

export { RoundButton };
